// extracted by mini-css-extract-plugin
export var grid = "_18-0";
export var span1 = "_18-2";
export var span10 = "_18-b";
export var span10L = "_18-z";
export var span10M = "_18-n";
export var span10Xl = "_18-1b";
export var span11 = "_18-c";
export var span11L = "_18-10";
export var span11M = "_18-o";
export var span11Xl = "_18-1c";
export var span12 = "_18-d";
export var span12L = "_18-11";
export var span12M = "_18-p";
export var span12Xl = "_18-1d";
export var span1L = "_18-q";
export var span1M = "_18-e";
export var span1Xl = "_18-12";
export var span2 = "_18-3";
export var span2L = "_18-r";
export var span2M = "_18-f";
export var span2Xl = "_18-13";
export var span3 = "_18-4";
export var span3L = "_18-s";
export var span3M = "_18-g";
export var span3Xl = "_18-14";
export var span4 = "_18-5";
export var span4L = "_18-t";
export var span4M = "_18-h";
export var span4Xl = "_18-15";
export var span5 = "_18-6";
export var span5L = "_18-u";
export var span5M = "_18-i";
export var span5Xl = "_18-16";
export var span6 = "_18-7";
export var span6L = "_18-v";
export var span6M = "_18-j";
export var span6Xl = "_18-17";
export var span7 = "_18-8";
export var span7L = "_18-w";
export var span7M = "_18-k";
export var span7Xl = "_18-18";
export var span8 = "_18-9";
export var span8L = "_18-x";
export var span8M = "_18-l";
export var span8Xl = "_18-19";
export var span9 = "_18-a";
export var span9L = "_18-y";
export var span9M = "_18-m";
export var span9Xl = "_18-1a";
export var stretch = "_18-1";